import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class QueryParamInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method === 'GET') {
      const url = new URL(req.urlWithParams);
      url.searchParams.forEach((value, key) => {
        if (key === 'filtro' || key === 'sort' || key === 'limit') {
            try {
            const decoded = JSON.parse(value);
            const encodedFiltro = encodeURIComponent(JSON.stringify(decoded));
            url.searchParams.set(key, encodedFiltro);
          } catch (e) {
            console.log(e)
          }
        }
      });

      const modifiedReq = req.clone({ url: url.toString() });
      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
